import type { StepConfig } from '../../types/workflow';

const pasteStepWithSubsteps: StepConfig = {
  icon: 'branch',
  headerTextColor: '#7C3AED',
  headerColor: '#EDE9FE',
  title: 'Paste step with sub-steps',
  text: 'Duplicate the full sequence',
  category: 'Node',
  hidden: true,
  isVirtual: true,
  virtualAction: 'pasteWithSubsteps',
  desc: 'Insert the copied step and all its nested steps.',
  formFields: [],
};

export default pasteStepWithSubsteps;
